import { t } from 'localization/utils/t';
import { startCase } from 'lodash';
import { camelCase, capitalize } from 'lodash/fp';
import { slugify } from 'shared/utils/consumerSearchSlugify';

const TP = 'productLandingPages.utils.createPlpHeadMetadata';

/**
 * [createPlpHeadMetadata]
 * takes in the display name for a product landing page and
 *
 */
export const createPlpHeadMetadata = ({ displayName }: { displayName: string }) => {
  const metaDescription = t(
    `${TP}.metaDescription`,
    'Shop {displayName} now on GOAT. Authenticity Assured.',
    { displayName },
  );
  const metaTitle = `${displayName} `;

  return { metaDescription, metaTitle };
};

export const getFashionSchema = (breadcrumbs) => {
  const brandName = breadcrumbs?.[0]?.slug?.includes('/brand/') ? breadcrumbs[0]?.name : null;

  return breadcrumbs?.map((crumb, i) => {
    if (i === 0 && brandName) {
      return {
        id: crumb.slug,
        name: crumb.name,
      };
    }

    return {
      id: crumb.slug,
      name: brandName
        ? t(
            `${TP}.brandName${capitalize(camelCase(crumb.name as string))}`,
            `{brand} ${capitalize(crumb.name as string)}`,
            {
              brand: brandName,
            },
          )
        : t(`${TP}.${capitalize(crumb.name as string)}`, `${capitalize(crumb.name as string)}`),
    };
  });
};

export const getSneakerSchema = (breadcrumbs, silhouette: string | undefined) => {
  const brandName = breadcrumbs?.[0]?.slug?.includes('/brand/') ? breadcrumbs[0]?.name : null;

  const newCrumbs = breadcrumbs?.map((crumb, i) => {
    if (i === 0 && brandName) {
      return {
        id: crumb.slug,
        name: crumb.name,
      };
    }

    return {
      id: crumb.slug,
      name: brandName
        ? t(
            `${TP}.brandName${capitalize(camelCase(crumb.name as string))}`,
            `{brand} ${capitalize(crumb.name as string)}`,
            {
              brand: brandName,
            },
          )
        : t(`${TP}.${capitalize(crumb.name as string)}`, `${capitalize(crumb.name as string)}`),
    };
  });

  if (silhouette) {
    return [
      ...newCrumbs,
      {
        id: `/sneakers/silhouette/${slugify(silhouette)}`,
        name: startCase(silhouette),
      },
    ];
  }

  return newCrumbs;
};
